import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportShipmentsPerformanceFilters, getReportShipmentsPerformanceAction } from "redux/actions/Reports/reportShipmentsPerformance/reportShipmentsPerformanceActions";
import { useSearch } from "hooks/useSearch";

export const ReportShipmentsPerformanceView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportShipmentsPerformance);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportShipmentsPerformanceAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Rendimientos de Embarque" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportShipmentsPerformance"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportShipmentsPerformanceFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingShipmentsPerformance}
      />
      {isLoadingComp?.loadingShipmentsPerformance && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
